import { render, staticRenderFns } from "./TeamRequestsPage.vue?vue&type=template&id=1c7d44be"
import script from "./TeamRequestsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamRequestsPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports